import { dataService } from "./services";
import { FancyCard } from "./components";
import { faFileContract } from "@fortawesome/free-solid-svg-icons";
import { ModuleTypeEnum } from "../../enums";
import { IModuleConfig } from "../../interfaces";
import AddButton from "../publications-module/components/toolbar-items/AddButton";
import {
  BackButton,
  CancelButton,
  EditButton,
  SaveButton,
} from "../publications-module/components/toolbar-items";
import { ItemPage } from "../publications-module/components";
import { DeleteButton } from "../publications-module/components/toolbar-items";

const config: IModuleConfig = {
  id: "publications",
  name: "Publications",
  icon: faFileContract,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  components: {
    libraryCard: FancyCard,
    itemPage: ItemPage,
  },
  services: {
    getByPage: dataService.getByPage,
    getSingle: dataService.getSingle,
    search: dataService.search,
  },
  utilities: {
    extractKey: (d: any) => d._id,
    extractItemPath: (d: any) => d._id,
    extractItemBreadcrumb: (d: any) => `${d.data.description}`,
  },
  toolbarItems: {
    library: [AddButton],
    create: [],
    edit: [SaveButton, CancelButton],
    view: [BackButton, EditButton, DeleteButton],
  },
};

export default config;
